export default __webpack_public_path__ + "static/content-img-l4-2-e7334ac4150eb426e6aa8e5a7be003de.png";